import { Routing } from '../Routes';
import { Main } from '../Main/Main';
import { Res, fetchResourceMap } from '../../state/api';
import { useConfig } from '../../config';
import './CampaignPage.css';
import { useTranslation } from '../../i18n/i18n';
import { CampaignProducts } from '../product/CampaignProducts';
import { Loop54CampaignProductsRequestBody } from '../../types';
import { generateUUID, renderTemplate } from '../utils';

const campaignPageProductLimit = 100;

export const CampaignPage = (): JSX.Element => {
	const { storeName } = useConfig();
	const t = useTranslation().campaigns;
	const headerText = renderTemplate(t.headerText, { storeName });

	return (
		<Main>
			<div className="campaign-page-header">
				<div className="banner">
					<img src="/images/campaigns-banner.jpg" />
				</div>
				<div className="header-text">
					<content-card>
						<h1>{t.campaignsHeading}</h1>
						<p>{headerText}</p>
					</content-card>
				</div>
			</div>
			<CampaignProducts take={campaignPageProductLimit} />
		</Main>
	);
};

export type UrlParams = { perma: string };

export const campaignRouting: Routing = {
	path(urls) {
		return urls.campaigns;
	},
	component: CampaignPage,
	requiresAuth: false,
	preload: async (config, _routeMatch, _query) => {
		const resultsLimit = campaignPageProductLimit;
		const offset = 0;
		const campaignProductsPayload: Loop54CampaignProductsRequestBody = {
			resultsOptions: {
				skip: offset,
				take: resultsLimit,
				sortBy: [
					{
						type: 'attribute',
						attributeName: 'boost',
						order: 'asc',
					},
				],
			},
			attribute: {
				name: 'campaignStr',
				value: ['true'],
			},
		};
		const loop54PostHeaders = {
			'Api-Version': 'V3',
			'User-id': generateUUID(),
		};

		const assets: Record<string, unknown> = await fetchResourceMap(
			config,
			Res.campaignProductsLoop54,
			{ take: resultsLimit },
			config.loop54Api,
			campaignProductsPayload,
			loop54PostHeaders,
			'POST'
		);

		return Object.assign({}, assets);
	},
};
